module.exports = __webpack_public_path__ + "static/media/Group 1702.afcb7fa8.png";